import apiClient from './index';

export const userApi = {
	// 로그인
	getUsers: async (loginData) => {
		return await apiClient.post('/members/log-in', loginData, {
			skipAuth: true
		});
	},
	// refresh token으로 access token 재발급
	reissueAccessToken: async () => {
		return await apiClient.post('/members/reissue-token');
	},
	// ID 중복확인
	checkDuplicateId: async (id) => {
		return await apiClient.get(`/members/check-id?id=${id}`, {
			skipAuth: true
		});
	},
	// 이메일 중복확인
	checkDuplicateEmail: async (email) => {
		return await apiClient.get(`/members/check-email?email=${email}`, {
			skipAuth: true
		});
	},
	// 회원가입
	signUp: async (userData) => {
		return await apiClient.post('/members/sign-up', userData, {
			skipAuth: true
		});
	},
	// 회원정보조회
	getUserInfo: async () => {
		return await apiClient.get('/members/my-info');
	},
	// 회원정보수정
	updateUserInfo: async (userData) => {
		return await apiClient.patch('/members/my-info', userData);
	},
	// 아이디찾기
	findUserId: async (requestBody) => {
		return await apiClient.post(`/members/find-id`, requestBody, {
			skipAuth: true
		});
	},
	// 비밀번호찾기
	findUserPw: async (requestBody) => {
		return await apiClient.post(`/members/find-password`, requestBody, {
			skipAuth: true
		});
	},
	// 회원탈퇴
	withdrawUser: async () => {
		return await apiClient.delete('/members/withdrawal');
	}
}